import { connect } from 'react-redux';
import { IUser } from '../../models';
import { IRootState } from '../../redux/state';
import { bindActionCreators, Dispatch } from 'redux';
import { setSelectedTab } from '../../redux/modules/reports/reportsCreators';
import ReportsMainPage from './ReportsMainPage';

function mapStateToProps(state: IRootState) {
  return {
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    selectedTab: state.reports.selectedTab,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    setSelectedTab: bindActionCreators(setSelectedTab, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsMainPage);
